import React, { Component } from "react";
import ReactDOM from "react-dom";
import PopupView from './PopupView';
import Overlay from "../../components/common/Overlay";

import "../../styles/popup.css";


let popupRoot = document.getElementById("popup-root");
if (!popupRoot) 
{
  const zeRoot = document.getElementById("root"); 
  popupRoot = document.createElement("div");
  document.body.insertBefore(popupRoot, zeRoot);
  popupRoot.id = "popup-root";
}

class Popup extends Component {

  render() {
    if (!this.props.isOpen) return null;

    return ReactDOM.createPortal(
      <Overlay>
        <PopupView onClose={this.props.closePopup} {...this.props}></PopupView>
      </Overlay>,
      popupRoot
    );
  }
}

export default Popup;
